export const srpTileStyles: (isDesktop: boolean) => ReactModal.Styles = (isDesktop: boolean) => ({
  content: {
    height: isDesktop ? 713 : '100%',
    width: isDesktop ? 570 : '100%',
    borderRadius: isDesktop ? 16 : '',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    zIndex: 1000,
    overflow: 'hidden',
    backgroundColor: 'rgba(0,0,0,.5)',
  },
});
